import { Dialog, DialogProps, useListGraphqlQuery, useTranslation, useTranslationRoute, useTranslations, useUrlParamsValueToString } from "@bsm/component"
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAddStudentMutation } from "../views/details/hooks/useAddStudentMutation";
import _ from "lodash";
import Mustache from 'mustache';

export const ConfirmAddStudentDialog = (props: TProps) => {

    const [
        OK,
        CANCEL,
    ] = useTranslations(i18n);

    const navigate = useNavigate();
    const tr = useTranslationRoute()
    const t = useTranslation()
    const urlParams = useUrlParamsValueToString()
    const mutation = useAddStudentMutation()

    useEffect(() => {
        if (mutation.isSuccess) {
            props.onClose()
            navigate(tr(`admin/students/viewer/scholarity/${props?.scholarityId}?${urlParams}`))
        }
    }, [mutation.isSuccess])

    const handleSubmited = () => {
        mutation.mutate({ scholarityId: props?.scholarityId, studentIds: props.studentIds, override: true })
    }

    return (
        <Dialog
            title={props?.message?.message === "SCHOLARITY_NOT_YET_ACTIVE" ? "Add student" : "Confirmation"}
            open={props.open}
            confirmation
            onClose={props.onClose}
            onCancel={props.onClose}
            onConfirm={handleSubmited}
            btnOk={{ label: OK, isSubmit: mutation.isLoading }}
            btnCancel={{ label: CANCEL }}
        >
            {
                props?.message?.message === "STUDENTS_ALREADY_HAVE_ACTIVE_SCHOLARITY" ?
                    <div>The student(s) bellow already have an active scholarity assignment. Would you like to proceed anyway ?</div> :
                    <div
                        dangerouslySetInnerHTML={{
                            __html: Mustache.render(t(props?.message?.message) ?? '', props?.message?.variables)
                        }}
                    ></div>
            }
            <ul className="list-disc pl-4 overflow-y-auto max-h-[150px] m-0 my-[20px] ml-[30px]">
                {
                    props?.message?.variables?.map((student, index) => (
                        <li key={index}>
                            {student?.fullName} ({student?.scholarityDesignation})
                        </li>
                    ))
                }
            </ul>
        </Dialog>
    )
}

const i18n = [
    "std_confirm",
    "std_cancel",
]

type TProps = Partial<DialogProps> & {
    scholarityId?: number,
    studentIds?: number[],
    message?: any
}